import { Text } from '@tonic-one/react';

import { useBlockTitleStyle } from '../style';

export default function BlockTitle(props: any) {
  const blockTitleStyle = useBlockTitleStyle();
  const { content, ...style } = props;
  return (
    <Text {...blockTitleStyle} {...style}>
      {content}
    </Text>
  );
}
